(() => {
  const TEE_PRODUCT_ID = 10344093253921;

  // Range Kit variant ID
  const GIFT_VARIANT_ID = 52212218528033;

  // Maximum number of free kits someone can receive in one order.
  // Change this if desired.
  const MAX_FREE_KITS = 3;

  const GIFT_ATTRIBUTE = '_clear_the_rack_gift';

  let syncing = false;
  let syncTimer = null;

  function scheduleSync(delay = 200) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGift, delay);
  }

  async function getAjaxCart() {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(`${root}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Could not load cart.');
    }

    return response.json();
  }

  async function syncGift() {
    if (syncing) return;
    if (!window.Shopify?.actions?.updateCart) return;

    syncing = true;

    try {
      const cart = await getAjaxCart();

      // Count every size/variant of the qualifying T-shirt.
      const teeQuantity = cart.items
        .filter((item) => Number(item.product_id) === TEE_PRODUCT_ID)
        .reduce((total, item) => total + item.quantity, 0);

      // 1 free Range Kit per shirt, capped at MAX_FREE_KITS.
      const desiredGiftQuantity = Math.min(
        teeQuantity,
        MAX_FREE_KITS
      );

      // Find only Range Kits that THIS script automatically added.
      const giftLines = cart.items.filter((item) => {
        return (
          Number(item.variant_id) === GIFT_VARIANT_ID &&
          item.properties &&
          String(item.properties[GIFT_ATTRIBUTE]) === 'true'
        );
      });

      const currentGiftQuantity = giftLines.reduce(
        (total, item) => total + item.quantity,
        0
      );

      // Nothing needs changing.
      if (currentGiftQuantity === desiredGiftQuantity) {
        return;
      }

      // Customer no longer has a qualifying shirt.
      // Remove promotional Range Kit(s).
      if (desiredGiftQuantity === 0) {
        if (giftLines.length) {
          await Shopify.actions.updateCart({
            lines: giftLines.map((item) => ({
              id: item.key,
              quantity: 0,
            })),
          });
        }

        return;
      }

      // Customer qualifies, but no promotional Range Kit exists yet.
      if (giftLines.length === 0) {
        await Shopify.actions.updateCart({
          lines: [
            {
              merchandiseId: String(GIFT_VARIANT_ID),
              quantity: desiredGiftQuantity,
              attributes: [
                {
                  key: GIFT_ATTRIBUTE,
                  value: 'true',
                },
              ],
            },
          ],
        });

        return;
      }

      // Gift already exists, but quantity needs to change.
      const primaryGift = giftLines[0];

      const lines = [
        {
          id: primaryGift.key,
          quantity: desiredGiftQuantity,
        },
      ];

      // Remove any accidental duplicate promotional lines.
      if (giftLines.length > 1) {
        giftLines.slice(1).forEach((item) => {
          lines.push({
            id: item.key,
            quantity: 0,
          });
        });
      }

      await Shopify.actions.updateCart({
        lines,
      });

    } catch (error) {
      console.error('Clear the Rack gift error:', error);
    } finally {
      syncing = false;
    }
  }

  /*
   * Horizon / Shopify 2026 standard cart event.
   *
   * Wait until the shopper's original cart change finishes,
   * then make sure the free Range Kit quantity is correct.
   */
  document.addEventListener('shopify:cart:lines-update', (event) => {
    // Ignore events generated by this script's own updateCart call.
    if (event.context === 'standard-action') return;

    if (event.promise && typeof event.promise.then === 'function') {
      event.promise
        .then(() => scheduleSync())
        .catch(() => {});
    } else {
      scheduleSync(400);
    }
  });

  /*
   * Also verify the promotion whenever the cart is opened.
   */
  document.addEventListener('shopify:cart:view', () => {
    scheduleSync();
  });

  /*
   * Catch carts that already contain the shirt when a page loads.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleSync(500);
    });
  } else {
    scheduleSync(500);
  }
})();